<template>
    <span class="flow-margin-left font-weight-bold">
        {{ propsPatient.name }}
        <span v-if="propsPatient.internalIds && propsPatient.internalIds.length > 0">
            ({{ propsPatient.internalIds.join(", ")}})
        </span>
        <span v-if="selectedPatientDevice">
            <i class="fa fa-mobile-alt flow-margin-right flow-green-active-color flow-padding-left" :title="$t('loggedIn')"></i>
        </span>
    </span>
</template>

<script>
    export default {
        props: ['propsPatient', 'selectedPatientDevice'],
        name: "PatientNameHeader"
    }
</script>